import { businessDate } from './smartReporting';
export const validFeeMonth = value => typeof value === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
export function studentFeeMonth(payment) {
  if (validFeeMonth(payment?.feeMonth)) return payment.feeMonth;
  const months = [...new Set((payment?.feeLines || []).filter(l=>l.type==='monthlyFee' && validFeeMonth(l.month)).map(l=>l.month))];
  return months.length===1 ? months[0] : businessDate(payment?.date).slice(0,7);
}
export const activeStudent = student => student?.status === 'active';
export function studentPaymentOption(student) {
  return { value: student._id, label: `${student.name || 'Unnamed'} (${student.studentId || 'ID unavailable'})${[...new Set([student.phone, student.whatsapp].filter(Boolean))].length ? ` — ${[...new Set([student.phone, student.whatsapp].filter(Boolean))].join(' / ')}` : ''}${student.course?.name ? ` — ${student.course.name}` : ''}`, __active: activeStudent(student) };
}
